module.exports = __webpack_public_path__ + "img/1f.b05d5f71.svg";